/* ============================================================================
FILE: po-peyi-la-collection-fr-en-es-20260727.js
ROLE: Description trilingue protégée de la collection « Péyi-la ».
ROOT: [data-po-peyi-la]
LANGUES: FR / EN / ES
STORAGE: po_lex_lang + goody_gp_lang
AUDIO: SpeechSynthesis, lecture du texte actif uniquement.
LIEN DE COLLECTION: aucun, la description étant affichée sur Péyi-la.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_PEYI_LA_COLLECTION_20260727__) return;
  window.__PO_PEYI_LA_COLLECTION_20260727__ = true;

  var ROOT_SELECTOR = "[data-po-peyi-la]";
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis)
    ? window.speechSynthesis
    : null;

  var AUDIO_STATE = {
    root: null,
    chunks: [],
    index: 0,
    active: false
  };

  function clampStr(value){
    return value == null ? "" : String(value);
  }

  function escapeHTML(value){
    return clampStr(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function canonical(value){
    return '<span class="po-peyi-collection__canonical notranslate" translate="no">' +
      escapeHTML(value) +
      "</span>";
  }

  var CANON = {
    title: canonical("Péyi-la"),
    guadeloupe: canonical("Guadeloupe")
  };

  var CONTENT = {
    fr: {
      ui: {
        group: "Choix de la langue",
        summary: "Description",
        audio: "Écouter",
        stop: "Arrêter",
        content: "Description de la collection Péyi-la"
      },
      paragraphs: [
        CANON.title + " se construit autour d’une réflexion sur l’équilibre improbable de nos sociétés. En les regardant depuis un dehors critique, et particulièrement en observant la société guadeloupéenne qui est la mienne, je m’étonne de la manière dont les structures continuent de tenir alors que tant de choses paraissent disloquées. Les corps, les mémoires, les héritages, les aspirations et les contraintes avancent ensemble dans une architecture instable, traversée par les tensions du pays et celles du monde.",

        "Nos vies y apparaissent prises dans des carcans d’incertitude, engagées dans des courses vers la survie, des marches devenues inertes et des inerties qui pèsent sur les choix à faire. Chacun cherche son axe, son appui et sa direction, tandis que la société impose ses rythmes, ses bifurcations et ses déséquilibres. La collection observe cette difficulté à avancer, cet instant où le mouvement demeure présent dans le corps alors que la trajectoire paraît suspendue, empêchée ou détournée.",

        "Le pied en supination revient comme une traduction plastique de cette tension permanente. Il porte le poids du corps sur son bord extérieur, expose la fragilité de l’appui et rend visible l’effort nécessaire pour rester debout, progresser ou choisir une direction. Il devient le signe d’une société qui avance de biais, cherche son équilibre au milieu des contraintes et transforme chaque pas en négociation avec le sol, l’histoire et l’incertitude.",

        "Ce motif ouvre seulement l’une des portes de la collection. Derrière les postures, les lignes, les couleurs, les torsions et les silences se déploient plusieurs histoires, parfois intimes, parfois collectives, parfois enfouies dans les gestes ordinaires. Chaque œuvre demande alors un regard capable de dépasser ce qui se montre immédiatement afin de percevoir les récits, les tensions et les héritages qui travaillent les formes depuis leur profondeur.",

        "La peinture devient ainsi une forme d’archéologie sociale. Elle fouille ce qui fait de nous ce que nous sommes, met en relation l’identité, les vécus, les souvenirs et les transformations du monde, puis observe la manière dont une singularité située peut s’ouvrir à une continuité plus universelle. Cette orientation était déjà présente dans les premières présentations de " + CANON.title + ", où la collection était décrite comme une réflexion sur l’identité, la prise de conscience et l’évolution du monde depuis un ancrage guadeloupéen.",

        CANON.title + " parle alors du pays comme territoire physique, social, historique, affectif et mental. Le pays devient l’espace où les appartenances se construisent, où les contradictions se rencontrent, où les blessures se transmettent et où les possibilités de transformation continuent de chercher leur forme. Il agit à la fois comme sol, mémoire, tension, abri et horizon.",

        "Chaque tableau porte ainsi plusieurs niveaux de lecture. Une posture peut contenir une lutte, une couleur peut réveiller une mémoire, une inclinaison peut révéler une résistance et un déséquilibre peut annoncer une autre manière de tenir debout. Le pied en supination demeure l’un des signes visibles de cette recherche, tandis que l’ensemble des œuvres ouvre un territoire beaucoup plus vaste, composé d’histoires à observer, à éprouver et à découvrir."
      ]
    },

    en: {
      ui: {
        group: "Language selection",
        summary: "Description",
        audio: "Listen",
        stop: "Stop",
        content: "Description of the Péyi-la collection"
      },
      paragraphs: [
        CANON.title + " is built around a reflection on the improbable balance of our societies. Looking at them from a critical outside perspective, and particularly at the Guadeloupean society that is mine, I am struck by the way structures continue to hold while so many things appear dislocated. Bodies, memories, inheritances, aspirations, and constraints move together within an unstable architecture crossed by the tensions of the country and those of the world.",

        "Our lives appear caught within frameworks of uncertainty, engaged in races for survival, walks turned inert, and forms of inertia that weigh upon the choices to be made. Each person seeks an axis, a point of support, and a direction, while society imposes its rhythms, bifurcations, and imbalances. The collection observes this difficulty of moving forward, this instant when movement remains present in the body while the trajectory seems suspended, obstructed, or diverted.",

        "The foot held in supination returns as a visual translation of this permanent tension. It carries the body’s weight along its outer edge, exposes the fragility of support, and makes visible the effort required to remain standing, move forward, or choose a direction. It becomes the sign of a society advancing at an angle, seeking balance among constraints, and transforming each step into a negotiation with the ground, history, and uncertainty.",

        "This motif opens only one of the collection’s doors. Behind the postures, lines, colours, torsions, and silences, several stories unfold, sometimes intimate, sometimes collective, sometimes buried within ordinary gestures. Each work therefore calls for a gaze capable of moving beyond what is immediately shown in order to perceive the narratives, tensions, and inheritances working within the forms from their depths.",

        "Painting thus becomes a form of social archaeology. It excavates what makes us who we are, brings identity, lived experiences, memories, and the transformations of the world into relation, then observes how a situated singularity can open onto a more universal continuity. This orientation was already present in the earliest presentations of " + CANON.title + ", where the collection was described as a reflection on identity, awareness, and the evolution of the world from a Guadeloupean grounding.",

        CANON.title + " then speaks of the country as a physical, social, historical, affective, and mental territory. The country becomes the space where belongings are formed, contradictions meet, wounds are transmitted, and possibilities for transformation continue to seek their form. It acts simultaneously as ground, memory, tension, shelter, and horizon.",

        "Each painting therefore carries several levels of interpretation. A posture may contain a struggle, a colour may awaken a memory, an inclination may reveal resistance, and an imbalance may announce another way of remaining upright. The foot in supination remains one of the visible signs of this inquiry, while the works as a whole open a much broader territory composed of stories to observe, experience, and discover."
      ]
    },

    es: {
      ui: {
        group: "Selección de idioma",
        summary: "Descripción",
        audio: "Escuchar",
        stop: "Detener",
        content: "Descripción de la colección Péyi-la"
      },
      paragraphs: [
        CANON.title + " se construye alrededor de una reflexión sobre el equilibrio improbable de nuestras sociedades. Al mirarlas desde una exterioridad crítica, y particularmente al observar la sociedad guadalupeña que es la mía, me sorprende la manera en que las estructuras siguen sosteniéndose mientras tantas cosas parecen dislocadas. Los cuerpos, las memorias, las herencias, las aspiraciones y las restricciones avanzan juntos dentro de una arquitectura inestable, atravesada por las tensiones del país y las del mundo.",

        "Nuestras vidas aparecen atrapadas en marcos de incertidumbre, involucradas en carreras por la supervivencia, marchas convertidas en inertes e inercias que pesan sobre las decisiones que deben tomarse. Cada persona busca su eje, su apoyo y su dirección, mientras la sociedad impone sus ritmos, sus bifurcaciones y sus desequilibrios. La colección observa esta dificultad para avanzar, ese instante en que el movimiento permanece presente en el cuerpo mientras la trayectoria parece suspendida, impedida o desviada.",

        "El pie en supinación reaparece como una traducción plástica de esta tensión permanente. Lleva el peso del cuerpo sobre su borde exterior, expone la fragilidad del apoyo y hace visible el esfuerzo necesario para permanecer de pie, progresar o elegir una dirección. Se convierte en el signo de una sociedad que avanza de lado, busca su equilibrio entre las restricciones y transforma cada paso en una negociación con el suelo, la historia y la incertidumbre.",

        "Este motivo abre solamente una de las puertas de la colección. Detrás de las posturas, las líneas, los colores, las torsiones y los silencios se despliegan varias historias, a veces íntimas, a veces colectivas, a veces enterradas en los gestos cotidianos. Cada obra exige entonces una mirada capaz de superar aquello que se muestra de inmediato para percibir los relatos, las tensiones y las herencias que trabajan las formas desde su profundidad.",

        "La pintura se convierte así en una forma de arqueología social. Excava aquello que hace de nosotros lo que somos, pone en relación la identidad, las experiencias vividas, los recuerdos y las transformaciones del mundo, y observa después la manera en que una singularidad situada puede abrirse a una continuidad más universal. Esta orientación ya estaba presente en las primeras presentaciones de " + CANON.title + ", donde la colección era descrita como una reflexión sobre la identidad, la toma de conciencia y la evolución del mundo desde un arraigo guadalupeño.",

        CANON.title + " habla entonces del país como territorio físico, social, histórico, afectivo y mental. El país se convierte en el espacio donde se construyen las pertenencias, donde se encuentran las contradicciones, donde se transmiten las heridas y donde las posibilidades de transformación continúan buscando su forma. Actúa a la vez como suelo, memoria, tensión, refugio y horizonte.",

        "Cada cuadro contiene así varios niveles de lectura. Una postura puede contener una lucha, un color puede despertar una memoria, una inclinación puede revelar una resistencia y un desequilibrio puede anunciar otra manera de permanecer de pie. El pie en supinación sigue siendo uno de los signos visibles de esta investigación, mientras el conjunto de las obras abre un territorio mucho más vasto, compuesto por historias que observar, experimentar y descubrir."
      ]
    }
  };

  function normLang(raw){
    var value = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");

    if (value === "fr" || value.indexOf("fr-") === 0) return "fr";
    if (value === "en" || value.indexOf("en-") === 0) return "en";
    if (value === "es" || value.indexOf("es-") === 0) return "es";

    return "fr";
  }

  function readStoredLang(){
    var value = "";

    try {
      value = localStorage.getItem(STORAGE_KEY) || "";
    } catch(e) {
      value = "";
    }

    if (!value) {
      try {
        value = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      } catch(_e) {
        value = "";
      }
    }

    return value ? normLang(value) : "";
  }

  function getLang(){
    var stored = readStoredLang();
    var htmlLang = "";

    if (stored) return stored;

    try {
      htmlLang = document.documentElement.getAttribute("lang") || "";
    } catch(e) {
      htmlLang = "";
    }

    return htmlLang ? normLang(htmlLang) : "fr";
  }

  function storeLang(lang){
    var resolved = normLang(lang);

    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch(e) {}

    try {
      localStorage.setItem(STORAGE_KEY_COMPAT, resolved);
    } catch(_e) {}

    try {
      document.documentElement.setAttribute("lang", resolved);
    } catch(__e) {}

    return resolved;
  }

  function paragraphHTML(paragraphs){
    return paragraphs.map(function(paragraph){
      return '<p class="po-peyi-collection__paragraph">' +
        paragraph +
        "</p>";
    }).join("");
  }

  function updateButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");

    Array.prototype.forEach.call(buttons, function(button){
      var active = normLang(button.getAttribute("data-po-lang")) === lang;

      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateUI(root, lang){
    var data = CONTENT[lang] || CONTENT.fr;
    var group = root.querySelector("[data-po-language-group]");
    var summaryLabel = root.querySelector("[data-po-summary-label]");
    var content = root.querySelector("[data-po-content]");
    var audio = root.querySelector("[data-po-audio]");

    root.setAttribute("lang", lang);
    root.setAttribute("aria-label", data.ui.content);

    if (group) group.setAttribute("aria-label", data.ui.group);
    if (summaryLabel) summaryLabel.textContent = data.ui.summary;
    if (content) content.setAttribute("aria-label", data.ui.content);

    if (audio) {
      audio.hidden = !AUDIO_SYNTH;
      audio.textContent = AUDIO_STATE.active && AUDIO_STATE.root === root
        ? data.ui.stop
        : data.ui.audio;
      audio.setAttribute(
        "aria-pressed",
        AUDIO_STATE.active && AUDIO_STATE.root === root ? "true" : "false"
      );
    }

    updateButtons(root, lang);
  }

  function renderRoot(root, lang){
    if (!root) return;

    var resolved = normLang(lang);
    var data = CONTENT[resolved] || CONTENT.fr;
    var content = root.querySelector("[data-po-content]");

    stopAudio();

    if (content) {
      content.classList.add("is-changing");

      window.setTimeout(function(){
        content.innerHTML = paragraphHTML(data.paragraphs);
        content.setAttribute("lang", resolved);
        content.classList.remove("is-changing");
      }, 80);
    }

    updateUI(root, resolved);
  }

  function applyLangEverywhere(lang){
    var resolved = normLang(lang);
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function(root){
      renderRoot(root, resolved);
    });
  }

  function notifyLocaleChanged(lang){
    try {
      window.dispatchEvent(new CustomEvent("po:locale-changed", {
        detail: {
          lang: lang,
          source: "po-peyi-la-collection"
        }
      }));
    } catch(e) {
      try {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("po:locale-changed", true, true, {
          lang: lang,
          source: "po-peyi-la-collection"
        });
        window.dispatchEvent(event);
      } catch(_e) {}
    }
  }

  function setLang(lang){
    var resolved = storeLang(lang);

    applyLangEverywhere(resolved);
    notifyLocaleChanged(resolved);

    return resolved;
  }

  function cleanAudioText(text){
    return clampStr(text)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function splitAudioText(text, maxLength){
    var clean = cleanAudioText(text);
    var limit = maxLength || 210;
    var sentences;
    var chunks = [];
    var current = "";

    if (!clean) return chunks;

    sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];

    sentences.forEach(function(sentence){
      var part = sentence.trim();

      if (!part) return;

      if (part.length > limit) {
        var words = part.split(/\s+/);

        words.forEach(function(word){
          var candidate = current ? current + " " + word : word;

          if (candidate.length > limit && current) {
            chunks.push(current.trim());
            current = word;
          } else {
            current = candidate;
          }
        });

        return;
      }

      if ((current + " " + part).trim().length > limit && current) {
        chunks.push(current.trim());
        current = part;
      } else {
        current = (current + " " + part).trim();
      }
    });

    if (current) chunks.push(current.trim());

    return chunks;
  }

  function voiceFor(lang){
    if (!AUDIO_SYNTH || typeof AUDIO_SYNTH.getVoices !== "function") {
      return null;
    }

    var voices = AUDIO_SYNTH.getVoices() || [];
    var locale = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var exact = null;
    var partial = null;

    voices.some(function(voice){
      var code = clampStr(voice.lang).toLowerCase();

      if (!exact && code === locale) exact = voice;
      if (!partial && code.indexOf(locale + "-") === 0) partial = voice;

      return Boolean(exact);
    });

    return exact || partial || null;
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      updateUI(root, lang);
    });
  }

  function resetAudioState(){
    AUDIO_STATE.root = null;
    AUDIO_STATE.chunks = [];
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = false;
    refreshAudioButtons();
  }

  function stopAudio(){
    if (AUDIO_SYNTH) {
      try {
        AUDIO_SYNTH.cancel();
      } catch(e) {}
    }

    resetAudioState();
  }

  function speakNext(){
    var root = AUDIO_STATE.root;
    var lang;
    var utterance;
    var voice;

    if (!AUDIO_SYNTH || !AUDIO_STATE.active || !root) {
      resetAudioState();
      return;
    }

    if (AUDIO_STATE.index >= AUDIO_STATE.chunks.length) {
      resetAudioState();
      return;
    }

    lang = normLang(root.getAttribute("lang") || getLang());
    utterance = new SpeechSynthesisUtterance(
      AUDIO_STATE.chunks[AUDIO_STATE.index]
    );
    voice = voiceFor(lang);

    utterance.lang = lang === "en"
      ? "en-US"
      : (lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    if (voice) utterance.voice = voice;

    utterance.onend = function(){
      AUDIO_STATE.index += 1;
      speakNext();
    };

    utterance.onerror = function(){
      resetAudioState();
    };

    AUDIO_SYNTH.speak(utterance);
  }

  function startAudio(root){
    var content;
    var text;

    if (!AUDIO_SYNTH || !root) return;

    if (AUDIO_STATE.active && AUDIO_STATE.root === root) {
      stopAudio();
      return;
    }

    stopAudio();

    content = root.querySelector("[data-po-content]");
    text = content ? content.textContent : "";

    AUDIO_STATE.root = root;
    AUDIO_STATE.chunks = splitAudioText(text, 210);
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = AUDIO_STATE.chunks.length > 0;

    refreshAudioButtons();

    if (AUDIO_STATE.active) speakNext();
  }

  function bindRoot(root){
    if (!root || root.getAttribute("data-po-bound") === "true") return;

    root.setAttribute("data-po-bound", "true");

    root.addEventListener("click", function(event){
      var langButton = event.target.closest("[data-po-lang]");
      var audioButton = event.target.closest("[data-po-audio]");

      if (langButton && root.contains(langButton)) {
        event.preventDefault();
        setLang(langButton.getAttribute("data-po-lang"));
        return;
      }

      if (audioButton && root.contains(audioButton)) {
        event.preventDefault();
        startAudio(root);
      }
    });
  }

  function initRoots(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      bindRoot(root);
      renderRoot(root, lang);
    });
  }

  window.addEventListener("po:locale-changed", function(event){
    var detail = event && event.detail ? event.detail : null;
    var lang = detail && detail.lang ? detail.lang : getLang();

    if (detail && detail.source === "po-peyi-la-collection") return;

    applyLangEverywhere(lang);
  });

  window.addEventListener("storage", function(event){
    if (!event) return;

    if (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT) {
      applyLangEverywhere(event.newValue || getLang());
    }
  });

  document.addEventListener("shopify:section:load", function(){
    initRoots();
  });

  document.addEventListener("shopify:section:unload", function(){
    stopAudio();
  });

  window.addEventListener("pagehide", function(){
    stopAudio();
  });

  window.PoPeyiLaCollectionFR_EN_ES_20260727 = {
    getLang: getLang,
    setLang: setLang,
    init: initRoots,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRoots, { once: true });
  } else {
    initRoots();
  }
})();
